/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Sebastian Hartmann <s.hartmann@techdivision.com>
 */

import React from 'react';
import {
  Divider, IconButton, InputBase, Paper,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import { useStudioSearchField } from './useStudioSearchField';
import './styles.scss';

/**
 * StudioSearchField Component
 * @param props
 * @returns {Element}
 * @constructor
 */
export function StudioSearchField(props) {
  const {
    handleClearInput,
    handleInputChange,
    handleCurrentPosition,
    handleSubmit,
    searchReference,
    clearInputVisible,
  } = useStudioSearchField(props);
  const { t } = useTranslation();

  /**
     * Render the search form
     * @returns {JSX.Element}
     */
  return (
    <Paper elevation={3} className="studio-search-field">
      <form onSubmit={handleSubmit}>
        <InputBase
          name="search-field"
          inputRef={searchReference}
          sx={{
            ml: 1,
            flex: 1,
          }}
          placeholder={t('searchPlaceholder')}
          inputProps={{ 'aria-label': 'Search' }}
          onChange={handleInputChange}
        />
        <IconButton sx={{ p: '10px' }} aria-label="search" type="submit">
          <SearchIcon />
        </IconButton>
        <Divider
          sx={{
            height: 28,
            m: 0.5,
          }}
          orientation="vertical"
        />

        {clearInputVisible ? (
          <IconButton onClick={handleClearInput} color="primary" sx={{ p: '10px' }} aria-label="directions">
            <CloseIcon />
          </IconButton>
        ) : (
          <IconButton
            onClick={handleCurrentPosition}
            color="primary"
            sx={{ p: '10px' }}
            aria-label="directions"
          >
            <GpsFixedIcon />
          </IconButton>
        )}
      </form>
    </Paper>
  );
}
